import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useHandleCallForHelpMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async keylocker_call_for_help_id => {
      await ApiInstance.post("/dashboard/handle_call_for_help", { keylocker_call_for_help_id }, ENV.keylockerBaseURL);
    },
    onSuccess: keylocker_call_for_help_id => {
      const callsForHelp = typedQueryClient.getQueryData(KeyLockersQueryKeys.callForHelp);
      if (!callsForHelp) return;

      const callForHelpIdx = callsForHelp.findIndex(callForHelp => callForHelp.keylocker_call_for_help_id === keylocker_call_for_help_id);
      if (callForHelpIdx === -1) return;

      typedQueryClient.setQueryData(KeyLockersQueryKeys.callForHelp, callsForHelp.toSpliced(callForHelpIdx, 1));
    }
  });
